import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import "../pagination/pagination.css"
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { IoAddSharp } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";

const UnitListing = () => {

    const apiService = new LeaseApiService();
    const [loading, setLoading] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setpropertyList] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        community: "",
        propertyName: null,
    })

    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        getItems()
    }, [])

    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyNo", formData?.propertyName?.value || "");
            params.append("UnitNo", formData?.community || "");
            const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
            setLoading(false)
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false)
        }
    }
    const columnDefs = [
        {
            headerName: '', field: 'scheduleId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, scheduleId) {
                    handleMenuAction(field, scheduleId);
                },
            }, width: 30,
        },
        { headerName: 'Ref no', field: 'ref_No', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
        { headerName: 'Property Name', field: 'property_Name', filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Unit No', field: 'unit_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Unit Type', field: 'unit_Type', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Unit Category', field: 'unit_Category', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Unit Class', field: 'unit_Class', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'BedRooms', field: 'bedrooms', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Total Area', field: 'total_Area', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Floor', field: 'floor', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Unit View', field: 'unit_View', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Rate / Sqft', field: 'sqft_Rate', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Rent / Annum', field: 'rent_Per_Annum', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Property No', field: 'property_No', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    ];
    const handleMenuAction = (action, rowData) => {
        switch (action) {
            case 'edit':
                handleEdit(rowData);
                break;
            case 'view':
                handleView(rowData);
                break;
            default:
                break;
        }
        setContextMenu(null); // Close the menu
    }
    const handleEdit = (rowData) => {
        navigate(`/Customer/Property/Master/Unit/Update`, { state: rowData });
    }
    const handleView = (rowData) => {
        navigate(`/Customer/Property/Master/Unit/vIew`, { state: rowData });
    }
    const handleClearFilters = () => {
        setFormData({
            community: "",
            propertyName: null,
        });
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handlenew = () => {
        navigate("/Customer/Property/Master/Unit/Create");
    }
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Community</label>
                                <input
                                    type="email"
                                    className="p-2 form-control w-75"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Property Name</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.propertyName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'propertyName', value: selectedOption })}
                                    options={propertyList?.map(prop => ({ value: prop, label: prop?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                    <FaFileCircleExclamation
                                        color="#fff"
                                        className="center mt-2 mx-2"
                                    />
                                    <div className="center">Search</div>
                                </div>
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-3'>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>Unit Listing</h5>
                            <div className="d-flex justify-content-end gap-1">
                                <div className="col center">
                                    <button
                                        className="mainbtn "
                                        type="submit"
                                        onClick={() => handlenew()}
                                    >
                                        <IoAddSharp color="#fff" className="center mt-1" />{" "}
                                        <div>Add</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='gridshad  mt-2'>
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
                {contextMenu && (
                    <div
                        style={{
                            position: 'absolute',
                            top: contextMenu.mouseY,
                            left: contextMenu.mouseX,
                            backgroundColor: 'white',
                            border: '1px solid gray',
                            zIndex: 1000,
                            padding: '10px 10px',
                            borderRadius: '8px',
                            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                        }}
                    >
                        {(() => {
                            const { scheduleId } = contextMenu.data || {};
                            // return (
                            //     <div>
                            //         <div>
                            //             <button className="btn btn-secondary" onClick={() => handleMenuAction('edit', contextMenu.data)}>
                            //                 Edit
                            //             </button>
                            //         </div>
                            //         <div>
                            //             <button className="btn btn-secondary" onClick={() => handleMenuAction('view', contextMenu.data)}>
                            //                 View
                            //             </button>
                            //         </div>
                            //     </div>
                            // );
                            return <div>No actions available</div>;
                        })()}
                    </div>
                )}
            </div>
        </div>

    );
};
export default UnitListing;
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center pt-1'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '25px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
